import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import api from '../../services/api'

type Status = 'loading' | 'success' | 'error'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const [status, setStatus] = useState<Status>(token ? 'loading' : 'error')

  useEffect(() => {
    if (!token) return

    api
      .post('/auth/verify-email', { token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'))
  }, [token])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full text-center space-y-4">
        {status === 'loading' && (
          <>
            <div className="animate-spin w-10 h-10 border-4 border-primary-500 border-t-transparent rounded-full mx-auto" />
            <h2 className="text-xl font-bold text-gray-900">Verifying your email...</h2>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-5xl">✅</div>
            <h2 className="text-xl font-bold text-gray-900">Email verified!</h2>
            <p className="text-gray-600">Your account is now fully activated.</p>
            <Link to="/login" className="btn-primary inline-block px-6 py-2">
              Sign in
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-5xl">❌</div>
            <h2 className="text-xl font-bold text-gray-900">Verification failed</h2>
            <p className="text-gray-600">
              The link is invalid or has expired. Please request a new one.
            </p>
            <Link to="/login" className="link block">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
